// initialize app & firestore routes to read from /deals by user ehail
import { v4 as uuidv4 } from 'uuid';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, getDocs, where, query, setDoc, doc, getDoc, addDoc, orderBy, onSnapshot, updateDoc, deleteDoc, increment } from 'firebase/firestore';
import { getAuth, signInWithPopup, signInWithCustomToken, GoogleAuthProvider, sendSignInLinkToEmail, isSignInWithEmailLink, signInWithEmailLink, signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage, ref, uploadBytes, getDownloadURL, listAll, deleteObject } from 'firebase/storage';
import { deleteVimeoVideo } from '../vimeo';

let firebaseConfig;

const NODE_ENV = process.env.NODE_ENV;
if (NODE_ENV === 'production') {
  firebaseConfig = {
    apiKey: "AIzaSyBnzqjZt_UcLjY6wpdUEfIk0yZybzKG3L4",
    authDomain: "partner-up-prod.firebaseapp.com",
    projectId: "partner-up-prod",
    storageBucket: "partner-up-prod.appspot.com",
    messagingSenderId: "1033616837777",
    appId: "1:1033616837777:web:d2d3c67bf2585465890330"
  };
} else {
  firebaseConfig = {
    apiKey: "AIzaSyBSiltELmJ0XtZ7tQYE6-Z1Eur4cyGmNIc",
    authDomain: "partner-up-staging.firebaseapp.com",
    projectId: "partner-up-staging",
    storageBucket: "partner-up-staging.appspot.com",
    messagingSenderId: "269501289751",
    appId: "1:269501289751:web:92c2d0ed06f1fb512f5352"
  };
}

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const storage = getStorage(app);

const functions = getFunctions(app, 'us-central1');
const acceptOfferCallable = httpsCallable(functions, 'acceptOffer');
const refundOfferCallable = httpsCallable(functions, 'refundOffer');
const declineOfferCallable = httpsCallable(functions, 'declineOffer');
const addContentEmail = httpsCallable(functions, 'addContentEmail');
const publishContentEmail = httpsCallable(functions, 'publishContentEmail');
const sendMessageEmail = httpsCallable(functions, 'sendMessageEmail');
const updateSocialsCallable = httpsCallable(functions, 'updateSocialsCallable');
const getStagingCustomToken = httpsCallable(functions, 'getStagingCustomToken');
export const sendSupportEmail = httpsCallable(functions, 'sendSupportEmail');
export const saveAddress = httpsCallable(functions, 'saveAddress');

const getStoreDataSecure = httpsCallable(functions, 'getStoreDataSecure');
const addCreatorCallable = httpsCallable(functions, 'addCreator');
const linkToStoreCallable = httpsCallable(functions, 'linkToStore');
export const checkEmail = httpsCallable(functions, 'checkEmail');
export const setupFirstLogin = httpsCallable(functions, 'setupFirstLogin');

export const getPaypalOnboardingLink = httpsCallable(functions, 'getPaypalOnboardingLink');

// export const getCreator = httpsCallable(functions, 'getCreator');
export const getDealData = httpsCallable(functions, 'getDealData')
export const getFormCreator = httpsCallable(functions, 'getFormCreator');

export const checkPaypalStatus = httpsCallable(functions, 'checkPaypalStatus');
export const checkCreatorAddress = httpsCallable(functions, 'checkCreatorAddress');

// emulator
if (NODE_ENV === 'development') {
  connectFunctionsEmulator(functions, 'localhost', 5001);
}

export const getCreator = async () => {
  // const uid = auth.currentUser?.uid;
  const email = auth.currentUser?.email;

  console.log('running', email)
  const creatorDocs = await getDocs(query(collection(firestore, 'creators'), where('email', '==', email)));

  if (creatorDocs.empty) {
    console.log('no creator found')
    return null;
  }

  const creators = creatorDocs.docs.map(doc => ({ ...doc.data(), id: doc.id }));

  const creatorData = creators.map(async (creator: any) => {
    const campaignsDocs = await getDocs(query(collection(firestore, 'deals'), where('creatorID', '==', creator.id), where('status', 'in', ['active', 'complete'])));
    const storeData = (await getDoc(doc(firestore, 'stores-public', creator.shop))).data()

    /*
    if (!creator?.uid) {
      await db.collection('creators').doc(creator.id).set({
        uid
      }, { merge: true })
    }
    */

    console.log('got data', {
      ...creator,
      deals: campaignsDocs.empty ? [] : campaignsDocs.docs.map(doc => ({ ...doc.data(), id: doc.id })),
      storeData
    })
    return {
      ...creator,
      deals: campaignsDocs.empty ? [] : campaignsDocs.docs.map(doc => ({ ...doc.data(), id: doc.id })),
      storeData
    }
  })

  const creatorD = await Promise.all(creatorData)
  console.log('returning', creatorD)

  return creatorD
}

export const getPublicStore = async (customDomain: string) => {
  const storeDocs = await getDocs(query(collection(firestore, 'stores-public'), where('customDomain', '==', customDomain)));
  if (storeDocs.empty) {
    // try to get by shop
    const shopifyDomain = `${customDomain}.myshopify.com`;
    const storeDoc = await getDoc(doc(firestore, 'stores-public', shopifyDomain));
    if (!storeDoc.exists()) {
      return null;
    }
    return { ...storeDoc.data(), id: storeDoc.id };
  } else {
    return { ...storeDocs.docs[0].data(), id: storeDocs.docs[0].id };
  }
}

export const signInWithStagingCustomToken = async (uid: string) => {
  try {
    const res: any = await getStagingCustomToken({ uid });
    await signInWithCustomToken(auth, res.data.token);
    return true
  } catch (e) {
    console.error(e);
    return false
  }
}

// sign in with google signInWithPopup
export const signInWithGoogle = async () => {
  try {
    const provider = new GoogleAuthProvider();
    await signInWithPopup(auth, provider);
    return true
  } catch (e) {
    console.error(e);
    return false
  }
}
export const emailPasswordSignIn = async (email: string, password: string) => {
  try {
    await signInWithEmailAndPassword(auth, email, password);
    return true
  } catch (e) {
    console.error;
    return false
  }
}

export const getDeal = async (dealID: string) => {
  console.log('dealID', dealID)
  const dealDoc = doc(firestore, 'deals', dealID);
  const deal = await getDoc(dealDoc);
  console.log('deal is', deal.data())
  const storePublicDoc = doc(firestore, 'stores-public', deal.data()!.shop);
  const storePublic = await getDoc(storePublicDoc);
  const campaignSubmission = doc(firestore, 'campaignSubmissions', dealID)
  const submission = await getDoc(campaignSubmission);
  return {
    ...deal.data(),
    id: deal.id,
    store: storePublic.data(),
    submitted: submission.exists()
  }
}

export const submitCampaign = async (dealID: string, formFields: any) => {
  const formDoc = doc(firestore, 'campaignSubmissions', dealID);
  const res = await setDoc(formDoc, { ...formFields, timestamp: new Date().toUTCString() });
  return res;
}

export const submitOnboarding = async (formID: string, formFields: any) => {
  console.log('adding', formFields)
  const res = await addDoc(collection(firestore, 'formResponses'), { ...formFields, formID, timestamp: new Date().toUTCString() });
  return res
}

export const savePaypalMerchantID = async (creatorID: string, data: { merchant_id: string, primary_email_confirmed: boolean, payments_receivable: boolean }, remove: boolean) => {
  const userDoc = doc(firestore, 'creators', creatorID);
  if (remove) {
    const updatedUser = await updateDoc(userDoc,
      {
        paypalMerchantID: null,
        paypalEmailConfirmed: null,
        paypalPaymentsReceivable: null,
        paypalOnboardingStarted: null
      });
    return updatedUser;
  } else {
    const updatedUser = await updateDoc(userDoc,
      {
        paypalMerchantID: data.merchant_id,
        paypalEmailConfirmed: data.primary_email_confirmed,
        paypalPaymentsReceivable: data.payments_receivable,
      });
    return updatedUser;
  }
}

export const createEmailSignIn = async (email: string, callback: any, urlString: string = '') => {
  sendSignInLinkToEmail(auth, email, {
    url: 'https://app.partnerup.net?emailLink=true' + urlString,
    handleCodeInApp: true,
  }).then(() => {
    window.localStorage.setItem('emailForSignIn', email);
    callback();
  }).catch((error) => {
    console.error(error.message);
  })
}

export const checkIfEmailLink = () => {
  if (isSignInWithEmailLink(auth, window.location.href)) {
    let email = window.localStorage.getItem('emailForSignIn') as string;
    if (!email) {
      email = window.prompt('Please provide your email for confirmation') as string;
    }
    signInWithEmailLink(auth, email, window.location.href).then((_: any) => {
      window.localStorage.removeItem('emailForSignIn');
    }).catch((error) => {
      console.error(error.message);
    })
  }
}

export const doPasswordReset = async (email: string) => {
  if (!email) {
    email = window.prompt('Enter your email') as string;
  }
  try {
    await sendPasswordResetEmail(auth, email)
    return true
  } catch (e) {
    alert('Error sending password reset email');
    return false
  }
}

export const setAccountSetupComplete = async () => {
  const uid = auth.currentUser?.uid;
  if (!uid) throw new Error('No user logged in');
  const userDoc = doc(firestore, 'influencers', uid);
  const updatedUser = await setDoc(userDoc, { stripeAccountSetupComplete: true }, { merge: true });
  return updatedUser;
}

export const getOnboardingForm = async (formID: string) => {

  const formDoc = await getDoc(doc(firestore, 'onboardingForms', formID))
  if (!formDoc.exists()) {
    return null
  }
  const storePublicDoc = doc(firestore, 'stores-public', formDoc.data()!.shop);
  const storeData = (await getDoc(storePublicDoc)).data()
  const form = {
    ...formDoc.data(),
    id: formDoc.id,
    storeData
  }

  // const formSubmitted = document.cookie.split('; ')?.find(row => row.startsWith('formSubmitted='))?.split('=')?.[1];
  const formViewed = document.cookie.split('; ')?.find(row => row.startsWith('formViewed='))?.split('=')?.[1];

  // if (formSubmitted === formID) {
  // return { responded: true, ...form }
  // } else {
  try {
    if (formViewed !== formID) {
      const formStatsRef = doc(firestore, 'formStats', formID);
      setDoc(formStatsRef, { views: increment(1) }, { merge: true });
      document.cookie = `formViewed=${formID}; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/`;
    }
    return form
  } catch (e) {
    console.error("Could not write form stats", e);
    return form
  }
  // }
}

export const getInfluencerByLoggedInUserEmail = async () => {
  const email = auth.currentUser?.email;
  const influencerRef = query(collection(firestore, 'influencers'), where('email', '==', email));
  const snapshot = await getDocs(influencerRef);
  if (snapshot.empty) return null;
  return { id: snapshot.docs[0].id, ...snapshot.docs[0].data() };
}

export const getInfluencerListener = (callback: (influencer: any) => void) => {
  const email = auth.currentUser?.email;
  const influencerRef = query(collection(firestore, 'creators'), where('email', '==', email));
  const unsubscribe = onSnapshot(influencerRef, (snapshot) => {
    if (snapshot.empty) return callback(null);
    const influencer = { id: snapshot.docs[0].id, ...snapshot.docs[0].data() };
    callback(influencer);
  });
  return unsubscribe;
}

export const getAllDealsForUser = async () => {
  const uid = auth.currentUser?.uid;
  if (!uid) throw new Error('No user logged in');
  const dealsRef = query(collection(firestore, 'deals'), where('influencerID', '==', uid), orderBy('lastUpdated', 'desc'));
  const snapshot = await getDocs(dealsRef);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data(), lastUpdated: doc.data().lastUpdated?.toDate() }));
}

export const getDealsListener = (
  callback: (deals: any[], snapshot: any) => void,
) => {
  const uid = auth.currentUser?.uid;
  const dealsRef = query(collection(firestore, 'deals'), where('influencerID', '==', uid), orderBy('lastUpdated', 'desc'));
  const unsubscribe = onSnapshot(dealsRef, (snapshot) => {
    const deals = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      lastUpdated: doc.data().lastUpdated?.toDate(),
      dueDate: doc.data().dueDate?.toDate(),
    }));
    callback(deals, snapshot);
  });
  return unsubscribe;
}

export const getPricesForUser = async () => {
  const uid = auth.currentUser?.uid;
  if (!uid) throw new Error('No user logged in');
  const pricesRef = query(collection(firestore, 'prices'), where('influencerID', '==', uid), where('archived', '!=', true));
  const snapshot = await getDocs(pricesRef);
  return snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
}

export const getPricesListener = (
  callback: (prices: any[]) => void,
) => {
  const uid = auth.currentUser?.uid;
  const pricesRef = query(collection(firestore, 'prices'), where('influencerID', '==', uid), where('archived', '!=', true));
  const unsubscribe = onSnapshot(pricesRef, (snapshot) => {
    const prices = snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
    callback(prices);
  });
  return unsubscribe;
}

export const getAddonsListener = (
  callback: (addons: any[]) => void,
) => {
  const uid = auth.currentUser?.uid;
  const addonsRef = query(collection(firestore, 'addons'), where('influencerID', '==', uid), where('archived', '!=', true));
  const unsubscribe = onSnapshot(addonsRef, (snapshot) => {
    const addons = snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
    callback(addons);
  });
  return unsubscribe;
}

export const getCaseStudiesListener = (
  callback: (caseStudies: any[]) => void,
) => {
  const uid = auth.currentUser?.uid;
  const caseStudiesRef = query(collection(firestore, 'caseStudies'), where('influencerID', '==', uid), where('archived', '!=', true));
  const unsubscribe = onSnapshot(caseStudiesRef, (snapshot) => {
    const caseStudies = snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
    callback(caseStudies);
  });
  return unsubscribe;
}

export const deleteCaseStudy = async (id: string) => {
  const caseStudyRef = doc(firestore, 'caseStudies', id);
  // delete doc
  await deleteDoc(caseStudyRef);
  await setCaseStudyCategoryCounts();
  return;
}

export const setNoCaseStudiesYet = async () => {
  const uid = auth.currentUser?.uid;
  if (!uid) throw new Error('No user logged in');
  const userDoc = doc(firestore, 'influencers', uid);
  const updatedUser = await setDoc(userDoc, { noCaseStudiesYet: true }, { merge: true });
  return updatedUser;
}

const setLowestPrice = async () => {
  const uid = auth.currentUser?.uid;
  if (!uid) throw new Error('No user logged in');
  const pricesRef = query(collection(firestore, 'prices'), where('influencerID', '==', uid), where('archived', '!=', true));
  const snapshot = await getDocs(pricesRef);
  let lowestPrice = 0;
  if (!snapshot.empty) {
    lowestPrice = snapshot.docs.reduce((acc, curr) => {
      if (Number(curr.data().price) < acc) return Number(curr.data().price);
      return acc;
    }, Number.MAX_SAFE_INTEGER);
  } else {
    lowestPrice = 0;
  }
  const userDoc = doc(firestore, 'creators', uid);
  const updatedUser = await setDoc(userDoc, { lowestPrice }, { merge: true });
  return updatedUser;
}

export const saveInfluencerPrice = async (price: any) => {
  // create new doc with random price id
  const uid = auth.currentUser?.uid;
  if (!uid) throw new Error('No user logged in');
  const priceObject = {
    ...price,
    influencerID: uid,
    archived: false,
  }
  const savePrice = { ...priceObject };
  if (savePrice.id) {
    delete savePrice.id;
  }
  const newPrice = await addDoc(collection(firestore, 'prices'), savePrice);
  await setLowestPrice();
  return newPrice;
}

export const saveAddon = async (addon: any) => {
  const uid = auth.currentUser?.uid;
  if (!uid) throw new Error('No user logged in');
  const addonObject = {
    ...addon,
    influencerID: uid,
    archived: false,
  }
  const saveAddon = { ...addonObject };
  if (saveAddon.id) {
    delete saveAddon.id;
  }
  const newAddon = await addDoc(collection(firestore, 'addons'), saveAddon);
  return newAddon;
}

export const tryToDeletePrice = async (id: string) => {
  const uid = auth.currentUser?.uid;
  if (!uid) throw new Error('No user logged in');
  // check deals by influencer ID and price ID
  const priceDoc = doc(firestore, 'prices', id);
  await setDoc(priceDoc, { archived: true }, { merge: true });
  await setLowestPrice();
  return;
}

export const tryToDeleteAddon = async (id: string) => {
  const uid = auth.currentUser?.uid;
  if (!uid) throw new Error('No user logged in');
  // check deals by influencer ID and price ID
  const addonDoc = doc(firestore, 'addons', id);
  await setDoc(addonDoc, { archived: true }, { merge: true });
  return;
}

export const tryToUpdatePrice = async (id: string, price: any) => {
  const uid = auth.currentUser?.uid;
  if (!uid) throw new Error('No user logged in');
  // check deals by influencer ID and price ID
  const priceDoc = doc(firestore, 'prices', id);
  await setDoc(priceDoc, { ...price }, { merge: true });

  await setLowestPrice();

  return true;
}

export const tryToUpdateAddon = async (id: string, addon: any) => {
  const uid = auth.currentUser?.uid;
  if (!uid) throw new Error('No user logged in');
  // check deals by influencer ID and price ID
  const priceDoc = doc(firestore, 'addons', id);
  await setDoc(priceDoc, { ...addon }, { merge: true });
  return true;
}

const setCaseStudyCategoryCounts = async () => {
  // read all case studies with uid
  // count categories
  // update creator doc with a map of category counts
  const uid = auth.currentUser?.uid;
  if (!uid) throw new Error('No user logged in');
  const caseStudiesRef = query(collection(firestore, 'caseStudies'), where('influencerID', '==', uid), where('archived', '!=', true));
  const snapshot = await getDocs(caseStudiesRef);
  const categoryCounts = snapshot.docs.reduce((acc, curr) => {
    const category = curr.data().category;
    if (acc[category]) {
      acc[category] += 1;
    } else {
      acc[category] = 1;
    }
    return acc;
  }, {} as any);
  const userDoc = doc(firestore, 'creators', uid);
  const updatedUser = await updateDoc(userDoc, { categoryCounts });
  return updatedUser;
}

export const saveCaseStudy = async (caseStudy: any) => {
  const uid = auth.currentUser?.uid;
  if (!uid) throw new Error('No user logged in');

  if (caseStudy.openID) {
    const caseStudyDoc = doc(firestore, 'caseStudies', caseStudy.openID);
    const updatedCaseStudy = await setDoc(caseStudyDoc, { ...caseStudy }, { merge: true });
    await setCaseStudyCategoryCounts();
    return updatedCaseStudy;
  } else {
    const caseStudyObject = {
      ...caseStudy,
      influencerID: uid,
      archived: false,
    }
    const newCaseStudy = await addDoc(collection(firestore, 'caseStudies'), caseStudyObject);
    await setCaseStudyCategoryCounts();
    return newCaseStudy;
  }

}

export const getBrand = async (shop: string) => {
  const brand = doc(firestore, 'stores', shop);
  const brandDoc = await getDoc(brand);
  return { ...brandDoc.data(), logo: brandDoc.data()?.logo };
}

export const getMultipleBrands = async (shops: string[]) => {
  const brands = shops.map(shop => doc(firestore, 'stores', shop));
  const brandDocs = await Promise.all(brands.map(brand => getDoc(brand)));
  return brandDocs.map(brand => ({ ...brand.data(), id: brand.id, logo: brand.data()?.logo }));
}

export const getPrice = async (priceID: string) => {
  const price = doc(firestore, 'prices', priceID);
  const priceDoc = await getDoc(price);
  return priceDoc.data();
}

export const getMultiplePrices = async (priceIDs: string[]) => {
  const prices = priceIDs.map(id => doc(firestore, 'prices', id));
  const priceDocs = await Promise.all(prices.map(price => getDoc(price)));
  return priceDocs.map(price => ({ id: price.id, ...price.data() }));
}

export const acceptOfferAndChargeCard = async (dealID: string) => {
  const res = await acceptOfferCallable({ dealID });
  return res;
}
export const refundOffer = async (dealID: string) => {
  const res = await refundOfferCallable({ dealID });
  return res;
}
export const declineOffer = async (dealID: string) => {
  const res = await declineOfferCallable({ dealID });
  return res;
}

export const undoAcceptOffer = async (dealID: string) => {
  const deal = doc(firestore, 'deals', dealID);
  await setDoc(deal, { status: 'offerSent', lastMessage: 'Accept was un-done', actionRequiredBy: 'influencer' }, { merge: true });
  return true;
}

export const markAsRead = async (dealID: string) => {
  const deal = doc(firestore, 'deals', dealID);
  await setDoc(deal, { unreadFor: null }, { merge: true });
  return true;
}

export const markBulkAsRead = async (dealIDs: string[]) => {
  const deals = dealIDs.map(id => doc(firestore, 'deals', id));
  await Promise.all(deals.map(deal => setDoc(deal, { isUnread: false }, { merge: true })));
  return true;
}

export const saveSettings = async (newSettings: { [key: string]: any }) => {
  const influencerRef = doc(firestore, 'influencers', auth.currentUser!.uid);
  await setDoc(influencerRef, newSettings, { merge: true });
  return true;
}

export const checkIfValidInviteID = async (type: 'store' | 'campaign', inviteID: string) => {
  let shop;
  if (type === 'store') {
    const invite = doc(firestore, 'storeInviteIDs', inviteID);
    const inviteDoc = await getDoc(invite);
    if (inviteDoc.exists()) {
      shop = inviteDoc.data()?.shop;
    }
  } else {
    const campaign = doc(firestore, 'campaigns', inviteID);
    const campaignDoc = await getDoc(campaign);
    shop = campaignDoc.data()?.shop;
  }
  if (shop) {
    const { data }: any = await getStoreDataSecure(shop)

    const onboardingForm = doc(firestore, 'storeForms', shop);
    const onboardingFormDoc = await getDoc(onboardingForm);

    return {
      valid: true,
      image: data.image,
      shop,
      shopName: data.name,
      campaign: type === 'campaign' ? inviteID : null,
      onboardingForm: onboardingFormDoc.exists() ? onboardingFormDoc.data() : null
    };
  } else {
    return { valid: false };
  }
}


export const acceptInvite = async (invite: any, formFields: any, customFields: any, callback: any) => {
  const uid = auth.currentUser?.uid;
  const email = auth.currentUser?.email;
  if (!uid) throw new Error('No user logged in');
  await linkToStoreCallable({
    creatorID: uid,
    shop: invite.shop,
    formFields,
    customFields,
    email
  })
  callback()
  return
}

export const createAccount = async (shop: string, invitedForCampaign: string | null) => {
  const email = auth.currentUser!.email;
  try {
    await addCreatorCallable({
      email,
      invitedBy: shop,
      invitedForCampaign,
      inviteMethod: 'link'
    });

  } catch (e: any) {
    console.error(e)
    return { error: e.message }
  }
  return true;
}

export const requestApproval = async () => {
  const creatorRef = doc(firestore, 'creators', auth.currentUser!.uid);
  await setDoc(creatorRef, { marketplaceStatus: 'pending' }, { merge: true }); // pending | approved | declined
  // send internal email notification
  await sendSupportEmail({ subject: auth.currentUser!.email + ' requested approval for marketplace (' + auth.currentUser!.uid + ')', text: 'Please review their profile and approve or decline' })
  return true;
}

export const setVisibileOnMarketplace = async (visibleOnMarketplace: string) => {
  const creatorRef = doc(firestore, 'creators', auth.currentUser!.uid);
  await setDoc(creatorRef, { visibleOnMarketplace }, { merge: true });
  return true;
}

export const linkAffiliate = async () => {
  const creatorEmail = auth.currentUser?.email;
  const affiliateInvitesRef = query(collection(firestore, 'affiliateInvites'), where('email', '==', creatorEmail));
  const affiliateInvitesSnapshot = await getDocs(affiliateInvitesRef);
  if (affiliateInvitesSnapshot.docs.length > 0) {
    const affiliateInvite = affiliateInvitesSnapshot.docs[0];
    const affiliateInviteRef = doc(firestore, 'affiliateInvites', affiliateInvite.id);
    await setDoc(affiliateInviteRef, { status: 'accepted', creatorID: auth.currentUser!.uid }, { merge: true });
  }
  return true;
}

export const getDiscountCodes = async () => {
  const uid = auth.currentUser!.uid;
  const discountCodesRef = query(collection(firestore, 'creatorDiscountCodes'), where('creatorID', '==', uid));
  const discountCodesSnapshot = await getDocs(discountCodesRef);
  return discountCodesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
}

export const getCreatorPayments = async () => {
  const uid = auth.currentUser!.uid;
  const paymentsRef = query(collection(firestore, 'creatorPayments'), where('creatorID', '==', uid));
  const paymentsSnapshot = await getDocs(paymentsRef);
  return paymentsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data(), timestamp: doc.data().timestamp?.toDate() }));
}

export const saveInfluencerProfileChanges = async (newProfileFields: { [key: string]: any }) => {
  const creatorRef = doc(firestore, 'creators', auth.currentUser!.uid);
  await setDoc(creatorRef, newProfileFields, { merge: true });
  return true;
}

export const getReviewForDeal = async (dealID: string) => {
  const review = doc(firestore, 'reviews', dealID);
  const reviewDoc = await getDoc(review);
  return reviewDoc.data();
}

export const submitReview = async (dealID: string, review: any) => {
  const reviewDoc = doc(firestore, 'reviews', dealID);
  const dealDoc = doc(firestore, 'deals', dealID);
  const dealData = await getDoc(dealDoc);

  const creatorData = await getDoc(doc(firestore, 'creators', dealData.data()?.influencerID));

  let bestAvatar = '';
  if (creatorData.data()?.socials?.instagram?.stats?.avatar) {
    bestAvatar = creatorData.data()?.socials?.instagram?.stats?.avatar;
  } else if (creatorData.data()?.socials?.tiktok?.stats?.avatar) {
    bestAvatar = creatorData.data()?.socials?.tiktok?.stats?.avatar;
  } else if (creatorData.data()?.socials?.youtube?.stats?.avatar) {
    bestAvatar = creatorData.data()?.socials?.youtube?.stats?.avatar;
  }

  await setDoc(reviewDoc, {
    creatorReview: {
      ...review,
      createdAt: new Date(),
      avatar: bestAvatar,
    },
    influencerID: dealData.data()?.influencerID,
    dealID,
    shop: dealData.data()?.shop,
  }, { merge: true });

  // set shop review average
  const reviewsRef = query(collection(firestore, 'reviews'), where('shop', '==', dealData.data()?.shop));
  const reviews = await getDocs(reviewsRef);
  const reviewData = reviews.docs.map(review => review.data()).filter(review => review.creatorReview?.stars)

  const average = reviewData.reduce((acc, review) => acc + Number(review.creatorReview.stars), 0) / reviewData.length;

  const shopRef = doc(firestore, 'stores', dealData.data()?.shop);
  await setDoc(shopRef, { reviewAverage: average, dealCount: reviews.docs.length }, { merge: true });

  await setDoc(dealDoc, { creatorReviewDone: true }, { merge: true });

  return true;
}

export const setContentUrls = async (dealID: string, urls: string[]) => {
  const deal = doc(firestore, 'deals', dealID);
  const dealData = await getDoc(deal);
  if (!dealData.exists()) {
    throw new Error('Deal does not exist');
  }

  // we added, rather than removed
  if (dealData.data()?.contentUrls?.length < urls.length) {
    await addContentEmail({ dealID });
  }
  // add to contentUrls array
  await setDoc(deal, {
    contentUrls: urls,
    status: 'review', lastMessage: `Content Version #${urls.length} Ready for Review`, isUnread: true, actionRequiredBy: 'shop'
  }, { merge: true });

  return true
}

export const saveDeploymentLink = async (dealID: string, link: string) => {
  const deal = doc(firestore, 'deals', dealID);
  await setDoc(deal, {
    deploymentLink: link,
    status: 'published',
    lastMessage: 'Content was Published!',
    isUnread: true,
    actionRequiredBy: 'shop',
    lastUpdated: new Date(),
    timeline: {
      published: new Date()
    }
  }, { merge: true });

  await publishContentEmail({ dealID });

  return true;
}

export const getMessagesByDealID = async (dealID: string) => {
  const dealRef = doc(firestore, 'deals', dealID);
  const dealDoc = await getDoc(dealRef);
  if (!dealDoc.exists) {
    throw new Error('Deal does not exist');
  }

  const messagesRef = collection(firestore, 'deals', dealID, 'messages');
  // get ordered by timestamp
  const messages = await getDocs(query(messagesRef, orderBy('timestamp', 'desc')));

  return messages.docs.map(doc => ({
    id: doc.id,
    ...doc.data(),
    timestamp: doc.data().timestamp.toDate(),
  }));
}

export const getContentListener = (
  dealID: string,
  callback: (content: any, snapshot: any) => void,
) => {
  const contentRef = collection(firestore, 'deals', dealID, 'content');
  const unsubscribe = onSnapshot(contentRef, (snapshot) => {
    const content = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));
    callback(content, snapshot);
  })
  return unsubscribe;
}

export const getContent = async (
  dealID: any,
) => {
  const contentRef = query(collection(firestore, 'content'), where('dealID', '==', dealID));
  const snapshot = await getDocs(contentRef);
  if (snapshot.empty) {
    return [];
  }
  return snapshot.docs.map((doc: any) => ({
    id: doc.id,
    ...doc.data(),
  }));
}
export const getPosts = async (
  dealID: any,
) => {
  const contentRef = query(collection(firestore, 'creatorPosts'), where('dealID', '==', dealID));
  const snapshot = await getDocs(contentRef);
  if (snapshot.empty) {
    return [];
  }
  return snapshot.docs.map((doc: any) => ({
    id: doc.id,
    ...doc.data(),
  }));
}

export const getMessagesListener = (
  dealID: string,
  callback: (messages: any) => void,
) => {
  const messagesRef = collection(firestore, 'deals', dealID, 'messages');
  const unsubscribe = onSnapshot(query(messagesRef, orderBy('timestamp', 'desc')), (snapshot) => {
    const messages = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      timestamp: doc.data().timestamp.toDate(),
    }));
    callback(messages);
  });
  return unsubscribe;
}

export const sendMessage = async (dealID: string, message: string) => {
  const influencer = doc(firestore, 'influencers', auth.currentUser!.uid);

  const dealRef = doc(firestore, 'deals', dealID);
  const dealDoc = await getDoc(dealRef);

  if (!dealDoc.exists) {
    throw new Error('Deal does not exist');
  }
  const structuredMessage = {
    message,
    timestamp: new Date(),
    authorID: influencer.id,
    authorType: 'influencer',
    messageType: 'dm'
  }

  await addDoc(collection(firestore, 'deals', dealID, 'messages'), structuredMessage);

  // queue email
  try {
    setDoc(dealRef, { unreadFor: 'store' }, { merge: true })
    sendMessageEmail({
      dealID: dealDoc.id,
      fromUserType: 'influencer',
      message: message
    });
  } catch (e) {
    console.error('error sending [new message] email', e)
  }

  return structuredMessage;
}

export const updateSocials = async (socials: { [key: string]: string }) => {
  // scrape data with callable function
  const responses = await updateSocialsCallable({ socials });
  return responses;
}

type Content = {
  id: string,
  status: string,
  directLink: string,
  deployLink: string,
  mostRecentUpload: string,
  timestamp: Date
}

async function setNewDealContentStatus(dealID: string, changeAction: 'add' | 'remove') {
  // update deal status to "needsContentOnly", or "needsContentAndReview" or "needsReviewOnly"
  // check all content docs for deal
  const allContentForDeal = query(collection(firestore, 'content'), where("dealID", '==', dealID));
  const contentDocs = await getDocs(allContentForDeal);
  if (contentDocs.empty) {
    throw new Error('No content for deal');
  }
  const content = contentDocs.docs.map(doc => ({
    id: doc.id,
    ...doc.data(),
  })) as Content[];

  const someNeedReview = content.some(c => c.status === 'changesRequested' || c.status === 'needsReview');
  const someNeedContent = content.some(c => c.status === 'needsContent');
  // const allDeployed = content.every(c => c.status === 'deployed');

  const newContentStatus = (someNeedReview && someNeedContent) ? 'needsContentAndReview'
    : someNeedReview ? 'needsReview'
      : someNeedContent ? 'needsContent'
        : 'allDeployed'

  let newFields: any = {
  }
  if (content.every(c => (c.mostRecentUpload || c.directLink || c.deployLink))) {
    newFields.allDraftsSubmitted = true
  }

  const dealRef = doc(firestore, 'deals', dealID);
  const dealDoc = await getDoc(dealRef);

  if (changeAction === 'add') {
    // check last upload timestamp
    const oldUploadTimestamp = dealDoc.data()?.content?.lastUploadEmailTimestamp?.toDate();
    const oneHourAgo = new Date();
    oneHourAgo.setHours(oneHourAgo.getHours() - 1);

    if (!oldUploadTimestamp || new Date(oldUploadTimestamp) < oneHourAgo) {
      newFields.lastUploadEmailTimestamp = new Date();
      await addContentEmail({
        dealID: dealID,
      })
    }
  }

  await setDoc(dealRef, {
    contentStatus: newContentStatus,
  }, { merge: true });

  return true;
}

export const updateServerContent = async (deal: any, contentID: string, newContent: { [key: string]: any }) => {
  let contentRef;
  let contentDoc;

  if (contentID) {
    contentRef = doc(firestore, 'content', contentID);
    contentDoc = await getDoc(contentRef);
    if (!contentDoc.exists()) {
      throw new Error('Content does not exist');
    }
  } else {
    contentRef = doc(collection(firestore, 'content'));
  }

  // delete from vimeo if mostRecentUpload exists and is different
  if (
    contentID &&
    contentDoc?.data()?.mostRecentUpload &&
    (newContent.directLink && contentDoc.data()?.mostRecentUpload) ||
    (contentDoc?.data()?.mostRecentUpload && contentDoc.data()?.mostRecentUpload !== newContent.mostRecentUpload)
  ) {
    const deleteRes = await deleteVimeoVideo(contentDoc.data()?.mostRecentUpload);
    if (!deleteRes) {
      console.error('Error deleting video from Vimeo');
    }
  }

  if (contentID) {
    await setDoc(contentRef, {
      mostRecentUpload: null,
      directLink: null,
      currentImages: [],
      ...newContent,
      changesOld: true,
      status: 'needsReview',
    }, { merge: true });
  } else {
    await addDoc(collection(firestore, 'content'), {
      dealID: deal.id,
      creatorID: deal.creatorID,
      shop: deal?.shop,
      mostRecentUpload: null,
      directLink: null,
      currentImages: [],
      ...newContent,
      changesOld: true,
      status: 'needsReview',
    })
  }

  /*
  await addDoc(collection(firestore, 'creators', deal.creatorID, 'messages'), {
    message: deal?.content?.reviewContent ? 'Content Uploaded For Review' : 'Content Deployed',
    timestamp: new Date(),
    messageType: 'event',
  });
  */

  await setNewDealContentStatus(deal.id, 'add');
  return true
}

export const deleteVimeoIDFromContent = async (dealID: string, contentID: string) => {
  // fetch content
  const contentRef = doc(firestore, 'deals', dealID, 'content', contentID);
  const contentDoc = await getDoc(contentRef);
  if (!contentDoc.exists()) {
    throw new Error('Content does not exist');
  }
  const vimeoID = contentDoc.data()?.mostRecentUpload as string;
  if (vimeoID) {
    // delete from vimeo
    await deleteVimeoVideo(vimeoID);
  }

  await setDoc(contentRef, {
    status: 'needsContent',
    mostRecentUpload: null,
    directLink: null,
  }, { merge: true });

  await setNewDealContentStatus(contentDoc.data()?.dealID, 'remove');
  return true;
}

export const uploadContentImages = async (contentID: string, images: File[]) => {
  const uid = auth.currentUser!.uid;
  // upload images to firebase storage
  const folderRef = ref(storage, `${uid}/${contentID}`);
  const oldFiles = await listAll(folderRef);

  const uploadPromises = images.map(async (image) => {
    const imageRef = ref(storage, `${uid}/${contentID}/${uuidv4()}`);
    // storage put
    await uploadBytes(imageRef, image);
    const imageURL = await getDownloadURL(imageRef);
    return {
      name: image.name,
      imageURL,
    }
  });
  const imageUploads = await Promise.all(uploadPromises);

  // delete old files
  if (oldFiles.items.length) {
    const deletePromises = oldFiles.items.map(async (file) => {
      await deleteObject(file);
    });
    await Promise.all(deletePromises);
  }

  return imageUploads;
}

